<template>
  <div>
    <a href="#/" class="btn btn-success" @click="showModal()">Send Quote</a>

    <b-modal id="bv-modal-example" hide-footer>
      <template #modal-title>New Quote</template>

      <div class="row text-white">
        <div class="col">
          <label class="form-label pt-0 mb-0" for="dealer-name">Price</label>
          <div class="mb-2"><small>How much can you complete this project for</small></div>

      <select class="form-select mb-2" v-model="price">
      <option value="0" disabled selected hidden>Please select</option>
      <option v-for="(budget, index) in budgets" :key="index" :value="budget.value">{{budget.name}}</option>
      </select>
        </div>
      </div>

      <div class="row text-white">
        <div class="col">
            <label class="form-label pt-0 mb-0" for="dealer-name">Note</label> <small>(optional)</small>
            <div class="mb-2"><small>Anything you want to say to the client</small></div>
            <textarea class="form-control shadow-none inputbox" rows="5" placeholder="" v-model="note"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Sending quote ...</button>
        <button v-else type="button" class="btn btn-success submit col" @click="sendQuote">Send Quote</button>
      </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['project'],

  data() {
    return {
      price: 0,
      note: '',
      updating: false,
      budgets: [],
      projectInfo: {},
    };
  },

  created() {
    this.populateBudgets();
  },

  methods: {

    populateBudgets() {

      let start = 50;
      let end   = 20000;
      let increment = 10;

      for (var i = start; i <= end; i+=increment) {
        var row = { value: i, name: this.formattedPrice(i) }
        this.budgets.push(row);
      }

    },

    showModal() {
      this.$bvModal.show("bv-modal-example");
    },

    hideModal() {
      this.$bvModal.hide("bv-modal-example");
    },

            sendQuote() {
        if (this.price == 0) {this.sweetfire('Please select a price')}

        else {

          this.updating = true;

          axios.post('/projects/send-quote', {
            project_id: this.project.id, 
            price: this.price, 
            note: this.note})
        .then((response) => {
          this.hideModal();
          this.updating = false;
          this.projectInfo = response.data;
          this.showToaster('Quote sent');
        })
        .catch(function (error) {
          console.log(error);
          this.updating = false;
        });

        }

      },

      showToaster(text) {
      this.$toaster.success(text, { timeout: 2500 });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
select.form-select {
  background-color: #ffffff !important;
  border: 2px solid #35363a;
}

.input-group-text.price {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding-left: 1.0rem;
}

input.form-control.price {
    padding-left: 0rem;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    }

.btn.btn-success.submit, .btn.btn-secondary.submit {
    border-radius: 5px !important;
}
</style>